/*
  Tokyo Romance Club — lightweight Wishlist (heart) feature.
  Storage: localStorage only, no app/server dependency. All state lives in
  one JSON array under STORAGE_KEY. To swap in a real Wishlist app later,
  replace getList/setList below — every button, badge, and the drawer all
  read through those two functions, nothing else touches storage directly.
  Fully disabled inside the theme editor (heart icons still render, but are
  inert) so it never fights with block selection or the customizer.
*/
(function () {
  if (window.__trcWishlistInit) return;
  window.__trcWishlistInit = true;

  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  var STORAGE_KEY = 'trc_wishlist_v1';

  function getList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function setList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('trc:wishlist:updated', { detail: { items: list, count: list.length } }));
  }

  function findIndex(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return i;
    }
    return -1;
  }

  function has(id) {
    return findIndex(getList(), id) > -1;
  }

  function add(item) {
    var list = getList();
    if (findIndex(list, item.id) === -1) {
      list.push(item);
      setList(list);
    }
    return list;
  }

  function remove(id) {
    var list = getList().filter(function (entry) {
      return String(entry.id) !== String(id);
    });
    setList(list);
    return list;
  }

  function toggle(item) {
    if (has(item.id)) {
      remove(item.id);
      return false;
    }
    add(item);
    return true;
  }

  window.trcWishlist = { getList: getList, has: has, add: add, remove: remove, toggle: toggle };

  if (designMode) return;

  function syncButton(button) {
    var id = button.getAttribute('data-id');
    var active = has(id);
    button.classList.toggle('trc-wishlist-toggle--active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'お気に入りから削除' : 'お気に入りに追加');

    var wrapper = button.closest('.wishlist-button-block');
    if (wrapper) {
      var label = wrapper.querySelector('[data-trc-wishlist-label]');
      if (label) label.textContent = active ? 'お気に入りに追加済み' : 'お気に入りに追加';
    }
  }

  function syncAllButtons() {
    var buttons = document.querySelectorAll('[data-trc-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) syncButton(buttons[i]);
  }

  function syncBadge() {
    var count = getList().length;
    var badges = document.querySelectorAll('[data-trc-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].classList.toggle('trc-wishlist-badge--empty', count === 0);
    }
  }

  function clearNode(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function renderDrawer() {
    var container = document.querySelector('[data-trc-wishlist-items]');
    var emptyState = document.querySelector('[data-trc-wishlist-empty]');
    if (!container) return;

    var list = getList();
    clearNode(container);

    if (!list.length) {
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;

    list.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'trc-wishlist-drawer__item';

      var link = document.createElement('a');
      link.href = item.url || '#';
      link.className = 'trc-wishlist-drawer__media';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.loading = 'lazy';
        img.alt = item.title || '';
        link.appendChild(img);
      }
      row.appendChild(link);

      var info = document.createElement('div');
      info.className = 'trc-wishlist-drawer__info';

      if (item.vendor) {
        var vendor = document.createElement('p');
        vendor.className = 'trc-wishlist-drawer__vendor';
        vendor.textContent = item.vendor;
        info.appendChild(vendor);
      }

      var titleLink = document.createElement('a');
      titleLink.href = item.url || '#';
      titleLink.className = 'trc-wishlist-drawer__title';
      titleLink.textContent = item.title || '';
      info.appendChild(titleLink);

      if (item.price) {
        var price = document.createElement('p');
        price.className = 'trc-wishlist-drawer__price';
        price.textContent = item.price;
        info.appendChild(price);
      }
      row.appendChild(info);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'trc-wishlist-drawer__remove';
      removeBtn.setAttribute('aria-label', (item.title || '') + ' をお気に入りから削除');
      removeBtn.textContent = '削除';
      removeBtn.addEventListener('click', function () {
        remove(item.id);
      });
      row.appendChild(removeBtn);

      container.appendChild(row);
    });
  }

  function syncAll() {
    syncAllButtons();
    syncBadge();
    renderDrawer();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-trc-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();

    var item = {
      id: button.getAttribute('data-id'),
      handle: button.getAttribute('data-handle') || '',
      title: button.getAttribute('data-title') || '',
      vendor: button.getAttribute('data-vendor') || '',
      price: button.getAttribute('data-price') || '',
      image: button.getAttribute('data-image') || '',
      url: button.getAttribute('data-url') || ''
    };
    if (!item.id) return;

    toggle(item);
  });

  document.addEventListener('trc:wishlist:updated', syncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
